import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  // FormControl,
  FormControlLabel,
  // FormLabel,
  // MenuItem,
  // Select,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { errorToastMessage, toastMessage } from "../../../utils/toast";
import { ModalActionButtonStyles } from "../../Common/styles/modal";
import { DrawerForm } from "../../Common/styles/drawer";
import http from "../../../utils/http";
import { AxiosResponse } from "axios";
// import { InputWrapper, LabelStyle } from "../../Common/styles/form";

type Props = {
  closeDrawer: () => void;
  refreshPage: () => void;
  studyId: string;
};

const SettingCheckbox: React.FC<{
  label: string;
  checked: boolean;
  onChange: () => void;
}> = ({ label, checked, onChange }) => (
  <>
    <FormControlLabel
      componentsProps={{
        typography: { sx: { fontSize: 16 } },
      }}
      sx={{ fontSize: 16, fontWeight: 500 }}
      control={<Checkbox checked={checked} onChange={onChange} />}
      label={label}
    />
    <Divider />
  </>
);

const Settings: React.FC<Props> = ({ closeDrawer, refreshPage, studyId }) => {
  const navigation = useNavigate();
  const [submitLoader, setSubmitLoader] = useState(false);
  const [settings, setSettings] = useState<{
    twoFactorAuth: boolean;
    selfRegister: boolean;
    // participantLoginStrategy: string;
  }>({
    twoFactorAuth: false,
    selfRegister: false,
    // participantLoginStrategy: "",
  });

  const handleCheckboxChange = (key: "twoFactorAuth" | "selfRegister") => {
    setSettings((prevSettings) => ({
      ...prevSettings,
      [key]: !prevSettings[key],
    }));
  };

  // const handleChange = (value: string) => {
  //   setSettings((prev) => ({
  //     ...prev,
  //     participantLoginStrategy: value,
  //   }));
  // };

  const handleSubmit = async () => {
    try {
      setSubmitLoader(true);
      let obj: any = {
        isMfaEnabled: settings.twoFactorAuth,
        isParticipantSelfRegistrationEnabled: settings.selfRegister,
        // participantLoginStrategy: settings.participantLoginStrategy,
      };
      const res: AxiosResponse = await http.put(
        `/study/${studyId}/settings/general`,
        obj
      );
      toastMessage("success", res.data.message);
      closeDrawer();
      refreshPage();
      navigation(`/studies/${studyId}/study-designer`);
    } catch (err) {
      errorToastMessage(err as Error);
    } finally {
      setSubmitLoader(false);
    }
  };

  return (
    <Box sx={DrawerForm}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2, p: 2.5 }}>
        <Typography
          fontSize="16px"
          fontWeight={400}
          color="text.secondary"
          mb={2}
        >
          Configure options like Two-Factor Authentication (2FA) for security
          and allow participants to self-register, tailoring the study setup to
          your needs.
        </Typography>
        <Divider />
        <SettingCheckbox
          label="Allow Two-Factor Authentication (2FA)"
          checked={settings.twoFactorAuth}
          onChange={() => handleCheckboxChange("twoFactorAuth")}
        />
        <SettingCheckbox
          label="Allow participant to self-register for the study"
          checked={settings.selfRegister}
          onChange={() => handleCheckboxChange("selfRegister")}
        />
      </Box>
      {/* <Box sx={{ p: 2.5 }}>
        <FormControl sx={InputWrapper}>
          <FormLabel sx={LabelStyle} htmlFor="login-strategy">
            Patient Login Strategy
          </FormLabel>
          <Select
            value={settings.participantLoginStrategy}
            id="login-strategy"
            onChange={(e) => handleChange(e.target.value)}
          >
            {[
              { key: "join_code", label: "Join Code" },
              { key: "passcode", label: "Passcode" },
              { key: "password", label: "Password" },
              // {
              //   key: "passcode_or_password",
              //   label: "Passcode or Password",
              // },
            ].map((item: any) => (
              <MenuItem key={item.key} value={item.key}>
                {item.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box> */}
      <Box sx={{ marginTop: "auto" }}>
        <Divider />
        <Box sx={{ ...ModalActionButtonStyles, mt: 2, mb: 0 }}>
          {!submitLoader ? (
            <Button variant="contained" onClick={handleSubmit}>
              Submit
            </Button>
          ) : (
            <CircularProgress size={25} />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Settings;
